import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=d7fda00a&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=d7fda00a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7fda00a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d7fda00a')) {
      api.createRecord('d7fda00a', component.options)
    } else {
      api.reload('d7fda00a', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=d7fda00a&scoped=true&", function () {
      api.rerender('d7fda00a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-270j5iEt9DSqh/JS/comp/GuestBox.vue"
export default component.exports